export default __webpack_public_path__ + "static/ghost_stumped-a69747a4c049ccc8ff2b1aeca1c5fbee.svg";